import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    arrangeOrder: 'asc',
    arrangeKey: 'CreatedOn',
    isLoading: false,
    operationObj: {},
    metrics: null,
    logs: null,
    appConfigList: [],
    appConfigDetailsLoader: false,
    appConfigListLoader: false,
    responseObject: '',
}

export const CSCEReducer = createSlice({
    name: 'CSCEReducer',
    initialState,
    reducers: {
        getMetricsListSuccess: (state, action) => {
            state.isLoading = true;
            state.metrics = action.payload;
            state.initateLoading = false;
        },
        getMetricsListFailure: (state, action) => {
            state.isLoading = false;
            state.metrics = null;
        },
        updateIsLoading: (state, action) => {
            state.isLoading = action.payload
        },
        updateOperationObj: (state, action) => {
            state.operationObj = action.payload
        },
        clearError: (state) => {
            state.error = null
        },
        getCSCELogsListSuccess: (state, action) => {
            state.isLoading = true;
            state.logs = action.payload;
            state.initateLoading = false;
        },
        getCSCELogsListFailure: (state, action) => {
            state.isLoading = false;
            state.logs = null;
        },
        getCSCEAppConfigSuccess: (state, action) => {
            // state.isLoading = true;
            state.appConfigList = action.payload;
            // state.initateLoading = false;
        },
        getCSCEAppConfigFailure: (state, action) => {
            // state.isLoading = false;
            state.appConfig = [];
        },
        updateAppConfigDetailsLoading: (state, action) => {
            state.appConfigDetailsLoader = action.payload
        },
        updateAppConfigListLoading: (state, action) => {
            state.appConfigListLoader = action.payload
        },
        updateResponseObject: (state, action) => {
            state.responseObject = action.payload
        },
    }

});

export const { getMetricsListSuccess, getMetricsListFailure, clearError, updateIsLoading, updateOperationObj, getCSCELogsListSuccess, getCSCELogsListFailure, getCSCEAppConfigSuccess, getCSCEAppConfigFailure, updateAppConfigListLoading, updateAppConfigDetailsLoading,updateResponseObject } = CSCEReducer.actions;

// Selectors
export const getCSCEselector = (state) => {
    return state.CSCEReducer;
};

export default CSCEReducer.reducer;